import React from 'react';
import FieldHelp from "../../../gd-components/help-and-hint/field-help/field-help";
import FieldProto from "../../../fields3/proto/field-proto";
import FormFieldError from "../../common/form-error/form-field-error";
import FormModel from "../../common/form-model-manager";

type Props = {

    field?         : FieldProto    // now mandatory
    form?          : FormModel // | FormManager - support only formModel !

    label?          : any         // can be string or component !!!
    labelClass?     : string
    width?          : number

    description?    : string | null

    className?      : string

    elementClass?: string
    errorClass?     : string
    // type?: 'default' | 'text' | 'text-multiline'
    onDelete?: callback

    fieldHelp?      : string,       // field help/hint message

    children?       : any

    isLast?         : boolean
}

export default function FormRowFlex(props:Props) {


    let fieldHelp = props.fieldHelp || props.field?.description
    // if (!fieldHelp && props.field && props.field.description) {
    //     fieldHelp = props.field.description
    // }

    const label = props.label || props.field?.label

    const labelStyle = {
        width       : _.get(props,'width', 150) + 'px',
        minWidth    : _.get(props,'width', 150) + 'px', // flex svoloch'...
    }
    const labelClass = props.labelClass ? props.labelClass : 'ui5-txt-not-important m-r-20 h-36 flex-row-left-center'

    const elementClasses = Classes("flex-column-left-top", props.elementClass, {})

    const classes = Classes("ui5-form-flex-row flex-row-left-top", props.className, {
        'm-b-20'        : !props.isLast
    })

    return (
        <div className={classes}>

            <div className={labelClass} style={labelStyle}>
                {label}
            </div>

            <div className={elementClasses}>

                <div className="flex-row-left-center max-w-100-percent">

                    {props.onDelete &&
                        <div className="ui5-field-with-delete-on-hover">
                            {props.children}
                            <div className="ui5-ico-trash red s-14" onClick={props.onDelete}/>
                        </div>}

                    {!props.onDelete && props.children}

                    {fieldHelp &&
                        <FieldHelp message={fieldHelp} className="m-l-10" />
                    }

                </div>

                {props.field && props.form &&
                    <FormFieldError className={props.errorClass} form={props.form} field={props.field} />
                }

                {props.description &&
                    <div className="ui5-txt-not-important-small m-t-5 lh-14em">{props.description}</div>
                }

            </div>

        </div>
    );

}
